import { useTenantViewMode } from '@/contexts/TenantViewModeContext';
import type { TenantViewMode } from '@/types/view-mode';

const OPTIONS: { id: TenantViewMode; label: string; title: string }[] = [
  {
    id: 'simple',
    label: 'Simple',
    title: 'Easy view — messages, bookings, and customers only',
  },
  {
    id: 'expert',
    label: 'Expert',
    title: 'Full dashboard — all channels, insights, and advanced settings',
  },
];

export function ViewModeToggle() {
  const { mode, setMode } = useTenantViewMode();

  return (
    <div
      className="flex items-center rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-card)] p-0.5"
      role="group"
      aria-label="Dashboard view mode"
    >
      {OPTIONS.map((option) => {
        const active = mode === option.id;
        return (
          <button
            key={option.id}
            type="button"
            title={option.title}
            aria-pressed={active}
            onClick={() => setMode(option.id)}
            className={[
              'rounded-md px-2.5 py-1 text-xs font-medium transition-colors',
              active
                ? 'bg-[var(--accent)] text-white shadow-sm'
                : 'text-[var(--text-secondary)] hover:text-[var(--text-primary)]',
            ].join(' ')}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
